import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LoginService } from '../../../login/login.service';
import { ReporteService } from '../reporte.service';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

import { PeriodoEjercicioService } from '../../../control/periodo.service';
@Component({
  selector: 'app-balanza-comprobacion',
  templateUrl: './balanza-comprobacion.component.html',
  styleUrls: ['./balanza-comprobacion.component.css'],
  providers: [ReporteService, DatePipe]
})
export class BalanzaComprobacionComponent implements OnInit {
  public anos: any[] = [];
  @ViewChild('table') table: ElementRef;
  public sinMovimiento: boolean;
  public saldoInicialFinal: boolean;
  public tipo: String;
  public reporte: any[] = [];
  private xlsx_pdf: any[] = [];
  public meses: any[] = [
    { numero: 1, nombre: 'enero' },
    { numero: 2, nombre: 'febrero' },
    { numero: 3, nombre: 'marzo' },
    { numero: 4, nombre: 'abril' },
    { numero: 5, nombre: 'mayo' },
    { numero: 6, nombre: 'junio' },
    { numero: 7, nombre: 'julio' },
    { numero: 8, nombre: 'agosto' },
    { numero: 9, nombre: 'septiembre' },
    { numero: 10, nombre: 'octubre' },
    { numero: 11, nombre: 'noviembre' },
    { numero: 12, nombre: 'diciembre' },
    {numero: 13, nombre: 'periodo_ajuste'}];
  public calculoSumaReporte: any = {
    titulo: '', saldo_inicial_deudor: 0,
    saldo_inicial_acreedor: 0, cargo: 0, abono: 0, saldo_final_deudor: 0, saldo_final_acreedor: 0
  };
  public ano: number;
  public list: any[] = [];
  public mes: number;
  public existencia: boolean;
  public pasivocapital: number;
  public actual: String;
  public fecha: String;
  rfc: any;
  public al: String;
  public empresa: String;
  cargado: boolean;
  constructor(private loginService: LoginService, private service: ReporteService, public datepipe: DatePipe, private PeriodoEjercicioService: PeriodoEjercicioService) {

  }

  ngOnInit(): void {
    this.fecha = new Date().toISOString().substring(0, 10);
    this.tipo = 'N';
    this.empresa = String(localStorage.getItem('empresa_nombre'));
    this.saldoInicialFinal = false;
    this.sinMovimiento = false;
    this.cargarAnos();
       this.PeriodoEjercicioService.periodo$
      .subscribe(periodo => {

        this.mes = periodo ? periodo : 13;
      });
    this.actual = String(this.datepipe.transform(new Date(), 'dd/MM/yyyy'));
    const diaFinalMesActual = new Date();
    this.al = String(this.datepipe.transform(new Date(diaFinalMesActual.getFullYear(), diaFinalMesActual.getMonth() + 1, 0), 'dd/MM/yyyy'));
    this.cargarReporte();
  }
  cargarAnos() {
    const ejercicios = JSON.parse(String(localStorage.getItem('ejercicios')));
    for (let x = 0; x < ejercicios.length; x++) {
      this.anos.push(ejercicios[x].anio);
    }
         this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.ano = ejercicio ? ejercicio : 0;

    });
    // this.cargarReporte();
  }
  calcularSuma() {
    this.calculoSumaReporte.titulo = 'SUMA TOTAL';
    this.calculoSumaReporte.saldo_inicial_deudor = 0;
    this.calculoSumaReporte.saldo_inicial_acreedor = 0;
    this.calculoSumaReporte.cargo = 0;
    this.calculoSumaReporte.abono = 0;
    this.calculoSumaReporte.saldo_final_deudor = 0;
    this.calculoSumaReporte.saldo_final_acreedor = 0;
    for (let x = 0; x < this.reporte.length; x++) {
      let separador = ''
      for (let y = 0; y < this.reporte[x].nivel_arbol; y++) {
        separador += '-- ';
      }
      this.reporte[x].cuenta = separador + this.reporte[x].cuenta;
      this.reporte[x].titulo = separador + this.reporte[x].titulo;
    }
    for (const item of this.reporte) {
      if (item.nivel_arbol === 0) {
        if ((!((item.cargo === 0) && (item.abono === 0) && (this.sinMovimiento)) ||
          (!this.sinMovimiento)) && (!((item.saldo_inicial === 0) && (item.saldo_final === 0)
            && (this.saldoInicialFinal)) || (!this.saldoInicialFinal))) {
          ////////////////////////////////////////////////////////////////////////
          if (item.naturaleza == 1 && item.saldo_inicial >= 0) {
            this.calculoSumaReporte.saldo_inicial_deudor += item.saldo_inicial;
          }
          if (item.naturaleza == 1 && item.saldo_final >= 0) {
            this.calculoSumaReporte.saldo_final_deudor += item.saldo_final;
          }
          if (item.naturaleza == 1 && item.saldo_inicial < 0) {
            this.calculoSumaReporte.saldo_inicial_acreedor += (item.saldo_inicial * -1);
          }
          if (item.naturaleza == 1 && item.saldo_final < 0) {
            this.calculoSumaReporte.saldo_final_acreedor += (item.saldo_final * -1);
          }
          ////////////////////////////////////////////////////////////////////////
          if (item.naturaleza == 2 && item.saldo_inicial >= 0) {
            this.calculoSumaReporte.saldo_inicial_acreedor += item.saldo_inicial;
          }
          if (item.naturaleza == 2 && item.saldo_final >= 0) {
            this.calculoSumaReporte.saldo_final_acreedor += item.saldo_final;
          }
          if (item.naturaleza == 2 && item.saldo_inicial < 0) {
            this.calculoSumaReporte.saldo_inicial_deudor += (item.saldo_inicial * -1);
          }
          if (item.naturaleza == 2 && item.saldo_final < 0) {
            this.calculoSumaReporte.saldo_final_deudor += (item.saldo_final * -1);
          }
          ////////////////////////////////////////////////////////////////////////
          this.calculoSumaReporte.cargo += item.cargo;
          this.calculoSumaReporte.abono += item.abono;
        }
      }
    }
  }
  toogle() {
    if (this.sinMovimiento == false) {
      this.sinMovimiento = true;
    } else {
      this.sinMovimiento = false;
    }
    this.calcularSuma();
  }
  toogle2() {
    if (this.saldoInicialFinal == false) {
      this.saldoInicialFinal = true;
    } else {
      this.saldoInicialFinal = false;
    }
    this.calcularSuma();
  }
  cargarReporte() {
    this.mostrarMensajeCarga('Se está generando tu reporte');
    this.service.getRepBalComp(this.loginService.empresa, this.mes, this.ano).subscribe(
      response => {
        const lista = response.contenido;
        this.reporte = lista;
        this.xlsx_pdf = lista;
        this.calcularSuma();
        this.list = [];
        for (const item of this.reporte) {
          if ((!((item.cargo === 0) && (item.abono === 0) && (this.sinMovimiento)) ||
            (!this.sinMovimiento)) && (!((item.saldo_inicial === 0) && (item.saldo_final === 0)
              && (this.saldoInicialFinal)) || (!this.saldoInicialFinal))) {
            this.list.push([item.titulo, item.saldo_inicial, item.cargo, item.abono, item.saldo_final]);
          }
        }
        this.list.push([this.calculoSumaReporte.titulo, this.calculoSumaReporte.saldo_inicial,
        this.calculoSumaReporte.cargo, this.calculoSumaReporte.abono, this.calculoSumaReporte.saldo_final]);
        this.cerrarMensajeCarga();
      }, err => {
        this.cerrarMensajeCarga();
      });
  }
  exportAsXLSX(tableID, filename = '') {
    if (this.list.length === 0) {
      Swal.fire('Aviso', 'La tabla no contiene datos el cual exportar a un archivo XLSX', 'warning');
    } else {
      this.service.getRepBalCompXlsx(this.loginService.empresa, this.mes==13?12: this.mes, this.ano, this.xlsx_pdf).subscribe(
        response => {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(response);
          a.download = 'Reporte_balanza_comprobacion_' + (this.mes==13?'periodo_ajuste':this.meses[this.mes-1].nombre) + '_' + this.ano + '.xls';
          document.body.appendChild(a);
          a.click();
        }
      );
    }
  }
  exportAsPDF() {
    if (this.list.length === 0) {
      Swal.fire('Aviso', 'La tabla no contiene datos el cual exportar a un archivo PDF', 'warning');
    } else {
      this.service.getRepBalCompPdf(this.loginService.empresa, this.mes==13?12: this.mes, this.ano, this.xlsx_pdf).subscribe(
        response => {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(response);
          a.download = 'Reporte_balanza_comprobacion_' + (this.mes==13?'periodo_ajuste':this.meses[this.mes-1].nombre) + '_' + this.ano + '.pdf';
          document.body.appendChild(a);
          a.click();
        }
      );
    }
  }
  cargarEmpresa() {
        this.rfc = this.loginService.usuario.empresa_seleccionada.rfc;
  }
  mostrarMensajeCarga(mensaje: string) {
    this.cargado = false;
    const numeros = [1, 2, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6];
    const aleatorio = numeros[Math.floor(Math.random() * numeros.length)];
    Swal.fire({
      html: `
      <div style="text-align: center">
        <h4><img src="/assets/gif/loading` + aleatorio + `.gif" width="80"/>
        <br><br><strong>Por favor espere...</strong><br><small>` + mensaje + `</small></h4>
      </div>`,
      toast: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
